export function formatDate(inputDate) {
	const date = new Date(inputDate);
	// Extract the day, month, and year from the date object
	const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits
	const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed, add 1
	const year = date.getFullYear();
	return `${day}.${month}.${year}`;
}
